import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import API from "../Network/API";

export default function ResetPassword() {
    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");
    const email = searchParams.get("email");
    const [isLoading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");


    useEffect(() => {
        const loaderElement = document.querySelector(".loading-mask");
        loaderElement.removeAttribute('hidden');
        if (loaderElement && !loaderElement.hasAttribute('hidden')) {
            loaderElement.setAttribute('hidden', 'true');
        }
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (typeof email !== "undefined") {
            if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/)) {
                toast.error('Email is not correct!');
                return false;
            }
        }

        var data = {
            token,
            email,
            password,
            password_confirmation: passwordConfirmation,
        }
        API.post('/v1/oauth/reset-password', data).then(response => {
            setLoading(false);
            toast.success(response.data.message)
            window.location.href = '/';
        return;
        }).catch((error) => {
            setLoading(false);
            console.log(error.response.data.message)
            toast.error(error.response.data.message??'Something was wrong')
           

        });
    }

    return (
        <>
        <section className="section-bg">
            <div className="container">
                <div className="row">
                    <div className="offset-md-2 col-lg-5 col-md-7 offset-lg-4 offset-md-3">
                        <div className="text-center mb-3 mt-5">

                            <img src="/img/imac-logo-black.png" className="imack-logo" alt="" width={200} />

                        </div>
                        <div className="card border bg-white">
                            <div className="panel-heading ">
                                <h3 className="pt-4 fw-bold pb-0">Reset Password</h3>
                            </div>
                            <div className="panel-body p-3">
                                <form onSubmit={submit}>
                                    <div className="form-group py-1">
                                        <input
                                            type="password"
                                            placeholder="New Password"
                                            value={password}
                                            className="form-control rounded-1 "
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group py-1">
                                        <input
                                            type="password"
                                            placeholder="Confirm Password"
                                             className="form-control rounded-1 "
                                            value={passwordConfirmation}
                                            onChange={(e) => setPasswordConfirmation(e.target.value)}
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary btn-block mt-3 fw-bolder" style={{ fontSize: '15px' }}>Submit {isLoading ? (
                                        <span
                                            className="spinner-border spinner-border-sm ml-5"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <span></span>
                                    )}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                 <div className="text-center mt-3">
                Powered By © <a href="#" className="copyright-link"><img src="/img/logo.png" style={{ width: '40px' }} alt="Logo" /></a>
              </div>
            </div>
        </section>
         <Toaster
                position="top-center"
                reverseOrder={false}
              />
        </>
    );
}